import { render, staticRenderFns } from "./PlatformManager.vue?vue&type=template&id=e98cf11c&lang=pug&"
import script from "./PlatformManager.vue?vue&type=script&lang=ts&"
export * from "./PlatformManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports